import React from 'react';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Slider from 'react-slick';
import { Modal, ModalBody } from 'reactstrap';
import Search from 'antd/es/input/Search';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus, faQuestion } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import { _danhSachHuongDanSuDung } from '../../api/baoHanh';
import { _danhSachDongSanPham, _danhSachThuongHieu } from '../../api/baoHanh';
import { setLoading } from '../../redux/loading/action';

const Video = (data) => {
    const { videos } = data;
    const [listData, setListData] = useState([]);
    const [showVideo, setShowVideo] = useState(null);

    const [modalYoutube, setModalYoutube] = useState(false);

    const extractYouTubeVideoId = (url) => {
        if (!url) return null;
        try {
            // Try URL object for ?v=VIDEOID format first
            const parsedUrl = new URL(url);
            if (parsedUrl.hostname.includes('youtu.be')) {
                // youtu.be/VIDEOID
                return parsedUrl.pathname.slice(1);
            }
            if (parsedUrl.hostname.includes('youtube.com')) {
                // youtube.com/watch?v=VIDEOID
                const v = parsedUrl.searchParams.get('v');
                if (v) return v;

                // youtube.com/shorts/VIDEOID or /embed/VIDEOID
                const paths = parsedUrl.pathname.split('/');
                const idIndex = paths.findIndex((p) => ['shorts', 'embed'].includes(p));
                if (idIndex !== -1 && paths.length > idIndex + 1) {
                    return paths[idIndex + 1];
                }
            }
            return null;
        } catch {
            const regex = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
            const match = url.match(regex);
            return match ? match[1] : null;
        }
    };

    const getEmbedLink = (url) => {
        const videoId = extractYouTubeVideoId(url);
        return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
    };

    const getThumbnailLink = (url) => {
        const videoId = extractYouTubeVideoId(url);
        return videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : '';
    };

    useEffect(() => {
        if (videos) {
            setListData(videos);
        }
    }, [videos]);

    const SampleNextArrow = (props) => {
        const { className, style, onClick } = props;
        return <div disabled={className?.includes('slick-disabled')} className={className} style={{ style, display: 'block' }} onClick={onClick} />;
    };

    const SamplePrevArrow = (props) => {
        const { className, style, onClick } = props;
        return <div disabled={className?.includes('slick-disabled')} className={className} style={{ style, display: 'block' }} onClick={onClick} />;
    };

    const toggleModalYoutube = (value) => {
        setModalYoutube(!modalYoutube);
        setShowVideo(value);
    };

    const rowsCount = listData.length > 10 ? 2 : 1;
    const pageSize = rowsCount * 5;

    return (
        <div className="list-slide-video">
            <Slider
                rows={rowsCount}
                slidesPerRow={1}
                slidesToShow={5}
                infinite={listData.length > pageSize}
                className="my-3"
                autoplay={false}
                loop={true}
                slidesToScroll={2}
                nextArrow={<SampleNextArrow />}
                prevArrow={<SamplePrevArrow />}
                responsive={[
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: listData == undefined || listData.length >= 3 ? 3 : listData.length,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: listData == undefined || listData.length >= 2 ? 2 : listData.length,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: listData == undefined || listData.length >= 1 ? 1 : listData.length,
                            slidesToScroll: 1,
                        },
                    },
                ]}
            >
                {listData.map((item, index) => (
                    <div key={index} className="video-slider position-relative">
                        <div onClick={() => toggleModalYoutube(item)}>
                            <div className="video-thumbnail-wrapper" style={{ cursor: 'pointer' }}>
                                <img src={getThumbnailLink(item.LinkVideo)} alt={item.TieuDe} style={{ width: '100%', height: 'auto', display: 'block' }} />
                                <div className="youtube-play-overlay" title="PLay video">
                                    <svg className="youtube-play-icon" viewBox="0 0 68 48" width="68" height="48">
                                        <path
                                            d="M66.52 7.85a8.27 8.27 0 0 0-5.82-5.83C56.59 1.2 34 1.2 34 1.2s-22.59 0-26.7.82a8.27 8.27 0 0 0-5.82 5.83C0.66 12 0.66 24 0.66 24s0 12 0.82 16.15a8.27 8.27 0 0 0 5.82 5.83c4.11.82 26.7.82 26.7.82s22.59 0 26.7-.82a8.27 8.27 0 0 0 5.82-5.83c0.82-4.11 0.82-16.15 0.82-16.15s0-12-0.82-16.15z"
                                            fill="#f00"
                                        />
                                        <path d="M26.6 33.6v-19.2l17.1 9.6-17.1 9.6z" fill="#fff" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="content-list-video mt-1" style={{ cursor: 'pointer' }}>
                            <h5 className="fw-bold tieude">
                                <div onClick={() => toggleModalYoutube(item)}>{item.TieuDe}</div>
                            </h5>
                        </div>
                    </div>
                ))}
            </Slider>
            {modalYoutube && (
                <Modal isOpen={modalYoutube} toggle={toggleModalYoutube} size="lg" className="modal-video-slider">
                    <ModalBody>
                        <p className="modal-video-youtube">
                            <iframe width="100%" src={getEmbedLink(showVideo.LinkVideo)} title={showVideo.TieuDe} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        </p>
                    </ModalBody>
                </Modal>
            )}
        </div>
    );
};

const BaiViet = ({ baiviet }) => {
    const [listData, setListData] = useState([]);

    useEffect(() => {
        if (baiviet) {
            setListData(baiviet);
        }
    }, [baiviet]);

    const SampleNextArrow = (props) => {
        const { className, style, onClick } = props;
        return <div disabled={className?.includes('slick-disabled')} className={className} style={{ style, display: 'block' }} onClick={onClick} />;
    };

    const SamplePrevArrow = (props) => {
        const { className, style, onClick } = props;
        return <div disabled={className?.includes('slick-disabled')} className={className} style={{ style, display: 'block' }} onClick={onClick} />;
    };

    const rowsCount = listData.length > 8 ? 3 : 1;
    const pageSize = rowsCount * 4;

    return (
        <Slider
            rows={rowsCount}
            slidesPerRow={1}
            slidesToShow={4}
            infinite={listData.length > pageSize}
            className="my-3"
            autoplay={false}
            loop={true}
            slidesToScroll={2}
            nextArrow={<SampleNextArrow />}
            prevArrow={<SamplePrevArrow />}
            responsive={[
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: baiviet == undefined || baiviet.length >= 3 ? 3 : baiviet.length,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: baiviet == undefined || baiviet.length >= 2 ? 2 : baiviet.length,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: baiviet == undefined || baiviet.length >= 1 ? 1 : baiviet.length,
                        slidesToScroll: 1,
                    },
                },
            ]}
        >
            {baiviet?.map((item, index) => (
                <div key={index} className="content-news-item">
                    <a href={item.LinkBaiViet} target="_blank" rel="noopener noreferrer">
                        <div className="item-thumb">
                            <img src={item?.Thumbnail && item?.Id ? `http://10.10.11.12/files/CmsHuongDanSuDung/BaiViet/${item.Id}/${item.Thumbnail}` : '/Logo-GigaDigital.png'} alt={item.TieuDe} className="rounded" />
                        </div>
                        <div className="item-content mt-2">
                            <h5>{item.TieuDe}</h5>
                        </div>
                    </a>
                </div>
            ))}
        </Slider>
    );
};

const Cauhoi = ({ questions }) => {
    const [listData, setListData] = useState([]);
    const [expanded, setExpanded] = useState(false); // track expand/collapse

    useEffect(() => {
        if (questions) {
            setListData(questions);
        }
    }, [questions]);

    const ldJson = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: listData.map((item) => ({
            '@type': 'Question',
            name: item.TieuDe,
            acceptedAnswer: {
                '@type': 'Answer',
                text: item.CauTraLoiNgan,
            },
        })),
    };

    const Item = ({ item }) => {
        const [showAnswer, setShowAnswer] = useState(true);

        const Linkify = ({ text, pattern, formatter }) => {
            const __html = text.replace(pattern, formatter);
            return <div dangerouslySetInnerHTML={{ __html }} />;
        };

        const text = item.CauTraLoiNgan;
        const pattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
        const formatter = (str) => `<a href="${str}" style="color:#3590de" target="_blank">${str}</a>`;

        return (
            <div className="card-question">
                <div className="card-question-item position-relative">
                    <div className="d-flex align-items-center justify-content-between mb-2 cursor-pointer" onClick={() => setShowAnswer(!showAnswer)}>
                        <div className="question-icon d-flex align-items-center">
                            <div className="item-icon">
                                <FontAwesomeIcon icon={faQuestion} className="icon" />
                            </div>
                            <h6 className="mb-0">
                                <b>{item.TieuDe}</b>
                            </h6>
                        </div>
                        <div className="button-show-answer">{showAnswer ? <FontAwesomeIcon icon={faPlus} /> : <FontAwesomeIcon icon={faMinus} />}</div>
                    </div>
                    {!showAnswer && (
                        <div className="list-answer">
                            <p>
                                <Linkify text={text} pattern={pattern} formatter={formatter} />
                            </p>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const visibleItems = expanded ? listData : listData.slice(0, 3);

    return (
        <div className="frequently-questions mt-3">
            {listData.length > 0 && (
                <>
                    {visibleItems.map((item, index) => (
                        <Item item={item} key={index} />
                    ))}

                    {listData.length > 3 && (
                        <div className="mt-2 text-center">
                            <button className="btn btn-link" onClick={() => setExpanded(!expanded)}>
                                {expanded ? 'Ẩn bớt' : 'Xem thêm'}
                            </button>
                        </div>
                    )}

                    <script type="application/ld+json">{JSON.stringify(ldJson)}</script>
                </>
            )}
        </div>
    );
};

const HuongDanSuDung = () => {
    const dispatch = useDispatch();
    const [maHang, setMaHang] = useState('');
    const [tukhoa, setTuKhoa] = useState('');
    const [hdsd, setHdsd] = useState(null);
    const [phanLoai, setPhanLoai] = useState('');
    const [thuonghieu, setThuongHieu] = useState('');
    const [loaiphukien, setLoaiPhuKien] = useState([]);
    const [IdSanPhamTuongThich, setIdSanPhamTuongThich] = useState([]);
    const [danhSachDongSanPhamEcovacs, setDanhSachDongSanPhamEcovacs] = useState([]);
    const [danhSachThuongHieuEcovacs, setDanhSachThuongHieuEcovacs] = useState([]);
    const [sptt, setSPTT] = useState('');
    const [showAll, setShowAll] = useState(false);
    const [showAllMenu, setShowAllMenu] = useState(false);
    const [showMegaThuongHieu, setShowMegaThuongHieu] = useState(false);
    const [showMegaCategory, setShowMegaCategory] = useState(false);

    const loadHuongDanSuDung = async (params = {}) => {
        dispatch(setLoading(true));
        try {
            const data = await _danhSachHuongDanSuDung(params.phanLoai ?? phanLoai, params.thuonghieu ?? thuonghieu, params.sptt ?? IdSanPhamTuongThich, params.tukhoa ?? tukhoa);

            setHdsd(data);
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(setLoading(false));
        }
    };
    useEffect(() => {
        const delay = setTimeout(() => {
            loadHuongDanSuDung();
        }, 300);

        return () => clearTimeout(delay);
    }, [thuonghieu, phanLoai, IdSanPhamTuongThich, tukhoa]);

    const chonPhanLoai = (data) => {
        setPhanLoai(data);
    };

    useEffect(() => {
        const onLoadData = async () => {
            await dispatch(setLoading(true));
            try {
                const [danhSachThuongHieu] = await Promise.all([_danhSachThuongHieu()]);
                setDanhSachThuongHieuEcovacs(danhSachThuongHieu);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                await dispatch(setLoading(false));
            }
        };
        onLoadData();
    }, []);

    const getThuongHieu = async (thuonghieu) => {
        setThuongHieu(thuonghieu);
        setLoaiPhuKien([]);
        setSPTT('');
        setShowMegaThuongHieu(false);
        _danhSachDongSanPham(thuonghieu).then((res) => {
            setDanhSachDongSanPhamEcovacs(res);
        });
    };

    const searchSanPham = (id, name) => {
        setIdSanPhamTuongThich(id);
        setSPTT(name);
    };

    const removeThuongHieu = () => {
        setThuongHieu('');
        setLoaiPhuKien([]);
        setSPTT('');
        setIdSanPhamTuongThich(null);
    };

    const removeSPTT = () => {
        setSPTT('');
        setIdSanPhamTuongThich(null);
    };

    const removeTuKhoa = () => {
        setTuKhoa('');
    };

    return (
        <div className="bg-light container rounded py-4">
            <h4 className="text-primary fw-bold mb-4 text-center">Hỗ trợ về sản phẩm</h4>

            <div className="card timkiem_filter mt-3">
                <div className="card-header d-block mb-0">
                    <div className="filter_product m-3">
                        <div className="list-search-category list-thuonghieu" style={{ display: 'flex' }} onClick={() => setShowMegaThuongHieu((prev) => !prev)}>
                            <div className="text-primary" style={{ marginRight: '31px' }}>
                                Tìm kiếm:
                            </div>
                            Thương hiệu&nbsp;
                            <span>
                                :<span className="text-primary"> {thuonghieu} </span>
                            </span>
                            &nbsp;
                            <i className="fa fa-caret-down cursor-pointer" />
                            <div className="row">
                                <div className={`w-100 mega-thuonghieu col-md-12 phukien_filter rounded p-3 ${!thuonghieu ? 'hoverable' : ''} ${showMegaThuongHieu && thuonghieu ? 'clicked' : ''}`}>
                                    {danhSachThuongHieuEcovacs &&
                                        (showAll ? danhSachThuongHieuEcovacs.filter((x) => x.CmsSttHienWeb) : danhSachThuongHieuEcovacs.filter((x) => x.CmsSttHienWeb).slice(0, 11)).map((item, index) => (
                                            <div key={index} style={{ width: '100%' }} className="col-md-2 tab_thuonghieu">
                                                <div
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        getThuongHieu(item.MaNhomHangChiTiet);
                                                        setShowMegaThuongHieu(false);
                                                    }}
                                                    className={`sub-label fw-bold text-primary tab_thuonghieu img cursor-pointer ${thuonghieu === item.MaNhomHangChiTiet ? 'active' : ''}`}
                                                >
                                                    <img src={item.CmsImageLink} alt={item.TenThuongHieu || 'Brand'} />
                                                </div>
                                            </div>
                                        ))}

                                    {!showAll && danhSachThuongHieuEcovacs?.length > 11 && (
                                        <div style={{ width: '100%' }} className="col-md-2 tab_thuonghieu d-flex align-items-center justify-content-center" onClick={() => setShowAll(true)} title="Xem thêm thương hiệu khác">
                                            <div className="sub-label fw-bold text-primary fs-3 cursor-pointer">…</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div
                            className="list-category"
                            tabIndex="0"
                            style={{ marginBottom: '6px' }}
                            onClick={() => {
                                if (sptt) {
                                    setShowMegaCategory((prev) => !prev);
                                }
                            }}
                        >
                            Sản phẩm tương thích&nbsp;
                            <span>
                                : <span className="text-primary">{sptt}</span>
                            </span>
                            &nbsp;
                            <i className="fa fa-caret-down" />
                            <div className={`w-100 mega-category rounded p-3 ${!sptt ? 'hoverable' : ''} ${showMegaCategory && sptt ? 'clicked' : ''}`}>
                                <div className="row">
                                    {danhSachDongSanPhamEcovacs &&
                                        danhSachDongSanPhamEcovacs
                                            .sort((a, b) => a.SttHienThi - b.SttHienThi)
                                            .map((item, index) => (
                                                <div key={index} className={item.length > 0 ? 'col-md-3 list' : 'col-md-3 only'}>
                                                    <div className="col-md-12 li">
                                                        <div className="sub-label fw-bold text-primary cursor-pointer">{item.TenDongSanPham}</div>
                                                    </div>
                                                    <div className="row" key={index}>
                                                        {item.SanPhamTuongThich &&
                                                            item.SanPhamTuongThich.length > 0 &&
                                                            item.SanPhamTuongThich.sort((a, b) => a.STT_HIEN_THI - b.STT_HIEN_THI).map((i, index) => (
                                                                <div
                                                                    className="sub-child-label cursor-pointer"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        searchSanPham(i.ID, i.TEN_SAN_PHAM_TUONG_THICH);
                                                                        setShowMegaCategory(false);
                                                                    }}
                                                                    key={index}
                                                                >
                                                                    {i.TEN_SAN_PHAM_TUONG_THICH}
                                                                </div>
                                                            ))}
                                                    </div>
                                                </div>
                                            ))}
                                </div>
                            </div>
                        </div>
                        <div className="list-search-category" style={{ width: '40%' }}>
                            <Search placeholder="Gõ từ khóa muốn tìm" enterButton="Tìm kiếm" size="large" onSearch={(value) => setTuKhoa(value)} onChange={(e) => setTuKhoa(e.target.value)} />
                        </div>
                    </div>
                </div>
                {(thuonghieu || sptt || tukhoa) && (
                    <div className="card-body">
                        <div className="d-flex align-items-center p-2">
                            <span>Đã chọn:</span>
                            {thuonghieu && (
                                <span className="badge bg-primary ms-2 cursor-pointer p-2" style={{ fontSize: '13px' }} onClick={removeThuongHieu}>
                                    {thuonghieu} <i className="fa fa-times ms-1"></i>
                                </span>
                            )}

                            {sptt && (
                                <span className="badge bg-primary ms-2 cursor-pointer p-2" style={{ fontSize: '13px' }} onClick={removeSPTT}>
                                    {sptt} <i className="fa fa-times ms-1"></i>
                                </span>
                            )}

                            {tukhoa && (
                                <span className="badge bg-primary ms-2 cursor-pointer p-2" style={{ fontSize: '13px' }} onClick={removeTuKhoa}>
                                    {tukhoa} <i className="fa fa-times ms-1"></i>
                                </span>
                            )}
                        </div>
                    </div>
                )}
            </div>

            {!thuonghieu && (
                <div className="res_pc">
                    <div className="fw-bold text-primary my-4 text-center" style={{ fontSize: '21px' }}>
                        Bạn đang tìm kiếm phụ kiện của thương hiệu nào?
                    </div>
                    <div className="col-md-12 phukien_filter mt-3">
                        {danhSachThuongHieuEcovacs &&
                            danhSachThuongHieuEcovacs
                                .filter((x) => x.CmsSttHienWeb)
                                .slice(0, showAllMenu ? undefined : 11)
                                .map((item, index) => (
                                    <div key={index} onClick={() => getThuongHieu(item.MaNhomHangChiTiet)} className="col-md-2 tab_thuonghieu d-flex align-items-center justify-content-center mb-3">
                                        <img src={item.CmsImageLink} alt={item.TenThuongHieu} />
                                    </div>
                                ))}

                        {!showAllMenu && danhSachThuongHieuEcovacs?.length > 11 && (
                            <div className="col-md-2 tab_thuonghieu d-flex align-items-center justify-content-center mb-3" onClick={() => setShowAllMenu(true)} style={{ cursor: 'pointer' }} title="Xem thêm thương hiệu khác">
                                <span className="fw-bold text-primary">Xem thêm …</span>
                            </div>
                        )}
                    </div>
                </div>
            )}

            <div className="card mt-4">
                <div className="card-header">
                    <div className="d-flex mb-3 mt-3 flex-wrap gap-3">
                        {['Hướng dẫn sử dụng', 'Mẹo nhỏ & tính năng hay', 'Khắc phục lỗi thường gặp', 'Trải nghiệm sản phẩm'].map((label) => (
                            <button key={label} className={`btn ${phanLoai === label ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => chonPhanLoai(label)}>
                                {label}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="card-body">
                    <div className="list-items-video">
                        {hdsd?.Video && (
                            <div className="items">
                                <h5>Video</h5>
                                <smal>
                                    <i>
                                        Đã tìm thấy <b>{hdsd.Video?.length}</b> kết quả
                                    </i>
                                </smal>
                                <Video videos={hdsd.Video}></Video>
                            </div>
                        )}
                        {hdsd?.BaiViet && (
                            <div className="items">
                                <h5>Bài viết</h5>
                                <smal>
                                    <i>
                                        Đã tìm thấy <b>{hdsd.BaiViet?.length}</b> kết quả
                                    </i>
                                </smal>
                                <BaiViet baiviet={hdsd.BaiViet}></BaiViet>
                            </div>
                        )}
                        {hdsd?.CauHoiNgan && (
                            <div className="items">
                                <h5>Câu hỏi thường gặp</h5>
                                <smal>
                                    <i>
                                        Đã tìm thấy <b>{hdsd.CauHoiNgan?.length}</b> kết quả
                                    </i>
                                </smal>
                                <Cauhoi questions={hdsd.CauHoiNgan}></Cauhoi>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HuongDanSuDung;
